import { render } from "./UserRoleProvider.vue?vue&type=template&id=e5bbd70c"
import script from "./UserRoleProvider.vue?vue&type=script&lang=js"
export * from "./UserRoleProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__